/* eslint-disable */
import React, { useEffect } from 'react';
import { Box, List, ListItem, Card, CardContent } from '@mui/material';
import { makeStyles } from '@mui/styles';
import DataListRow from './dataListRow';
import { createTheme } from '@mui/material/styles';
import EnhancedTableToolbar from '../../sharedcomponents/tableToolbar/tableToolbar';
import Paging from '../../sharedcomponents/pagination/pagination';
// import DraggableList from './draggableList';
import DetailsComponent from '../../sharedcomponents/detailsComponent/DetailsComponent';
import { useEventState } from '../../stores/eventStore';
import { useState } from '@hookstate/core';
import Title from '../../sharedcomponents/title/title';
import moment from 'moment';
import CultureInfo from '../../utility/cultureInfo';
import Helper from '../../utility/helper';

const theme = createTheme();

const useStyles = makeStyles(() => ({
    boxContent: {
        // paddingTop: theme.spacing(1),
    },
    listContent: {
        paddingBottom: theme.spacing(0),
        zIndex: 0,
    },
    cardContent: {
        padding: 0,
        '&:last-child': {
            paddingBottom: 0,
        },
    },
    rowContent: {
        flex: 1,
        display: 'flex',
        justifyContent: 'center',
    },
    listItemContent: {
        padding: theme.spacing(1, 0),
    },
    paperContent: {
        boxShadow:
            'rgb(145 158 171 / 24%) 0px 0px 2px 0px, rgb(145 158 171 / 24%) 0px 16px 32px -4px',
        borderRadius: theme.spacing(2),
        padding: theme.spacing(1),
        backgroundColor: '#fff',
        border: '1px solid #efefef',
    },
}));

const DataList = (props) =>
{
    const classes = useStyles();

    const [listData, setListData] = React.useState([]);
    const [filterListData, setFilterListData] = React.useState([]);
    const [search, setSearch] = React.useState('');
    const eventState = useEventState();
    const moduleIndex = useState(-1);
    const [hotelRoomTaxID, setHotelRoomTaxID] = React.useState({
        index: '',
        value: 0,
    });
    useEffect(() =>
    {
        setListData(props.data);
        // if(props.bulkInviteSelected){
        //     setFilterListData(filterData());

        // }
        //     if (listData && listData.length == 0 && filterListData.length == 0) {
        //         setListData(props.data);
        //         setFilterListData(props.data);
        //     } else if (
        //         props.showSearchRec &&
        //         props.data.length != listData.length
        //     ) {
        //         setListData(props.data);
        //         setFilterListData(props.data);
        //     } else if (!props.showSearchRec) {
        //         setListData(props.data);
        //         setFilterListData(props.data);
        //     }

        if (
            eventState &&
            eventState.eventDetail.get() != null &&
            props.moduleToShow != undefined
        )
        {
            getModuleDetailsData();
        }
    }, [props]);
    useEffect(() =>
    {
        setFilterListData(props.data);

    }, [])

    const getModuleDetailsData = () =>
    {
        const index = eventState.eventDetail
            .get()
            .moduleDetails.findIndex((element) =>
            {
                if (
                    element.moduleName ===
                    (props.titleHeader ? props.titleHeader : props.moduleToShow)
                )
                {
                    return true;
                }
            });
        moduleIndex.set(index);
    };

    // this need to be modified
    const handleFilterChangeValue = (filterObj) =>
    {
        let modifyList = listData.filter((item) =>
        {
            const data = item.actualData;
            if (filterObj)
            {
                return Object.keys(filterObj).every((filter) =>
                {
                    let val =
                        typeof filterObj[filter] === 'string' &&
                            filter === 'transportType'
                            ? filterObj[filter].toLowerCase()
                            : filterObj[filter];
                    return val.includes(data[filter]);
                });
            }
        });

        if (filterObj)
        {
            if (props.setShowSearchRec != undefined)
            {
                props.setShowSearchRec(true);
            }
            setFilterListData(modifyList);
            props.filterListData(modifyList);
        } else
        {
            if (props.setShowSearchRec != undefined)
            {
                props.setShowSearchRec(false);
            }
            setFilterListData(listData);
            if (props.filterListData) props.filterListData(listData);
        }
    };
    const filterData = () =>
    {
        let newFilterSearchData = [];
        props.userSearchData.map((item) =>
        {
            newFilterSearchData.push({
                actualData: item,
                row: [
                    {
                        label: 'checkbox',
                        key: 'userID',
                        userID: item.userID,
                        width: '0.05',
                    },
                    // {
                    //     label: 'First Name',
                    //     key: 'firstName',
                    //     firstName: item.firstName,
                    //     inColumn: true,
                    //     width: '0.15',
                    // },
                    // {
                    //     label: 'Last Name',
                    //     key: 'lastName',
                    //     lastName: item.lastName,
                    //     inColumn: true,
                    //     width: '0.15',
                    // },
                    // {
                    //     label: 'Email',
                    //     key: 'email',
                    //     email: item.email,
                    //     inColumn: true,
                    //     width: '0.25',
                    // },
                    {
                        label: 'Name',
                        key: 'participant',
                        participant: item.lastName + ',' + item.firstName,
                        showLabel: false,
                        width: '0.25',
                        inColumn: true,
                        showEmail: true,
                        toEmail: item.email,
                    },
                    {
                        label: 'Login ID',
                        key: 'email',
                        email: item.loginID,
                        inColumn: true,
                        width: '0.3',
                    },
                    {
                        label: 'Role',
                        key: 'roleName',
                        roleName: item.roleName,
                        inColumn: true,
                        width: '0.1',
                    },
                    {
                        label: 'Registered On',
                        key: 'registerDate',
                        registerDate:
                            item.registerDate != null
                                ? moment(item.registerDate).format(
                                    CultureInfo.GetCultureInfo()
                                        .DateTimeFormat
                                )
                                : '',
                        inColumn: true,
                        width: '0.15',
                        isSent: true,
                    },
                    {
                        label: 'Status',
                        key: 'status',
                        status: item.active ? 'Active' : 'Inactive',
                        width: '0.07',
                        inColumn: true,
                    },
                    {
                        label: 'SenUserMail',
                        key: 'sendUserMail',
                        showLabel: false,
                        width: '0.03',
                        showEmailIcon: item.status == 0 ? true : false,
                    },
                    {
                        label: 'ClipBoard',
                        key: 'clipBoard',
                        width: '0.03',
                        showClipBoardIcon: item.status == 0 ? true : false,
                    },
                    {
                        label: 'Action',
                        key: 'edit',
                        edit: 'Edit',
                        width: '0.02',
                    },
                ],
                selected: false,
            });
        });
        return newFilterSearchData;
    };
    const handleOnChange = (event) =>
    {
        let str = event.target.value;
        const value = str.replace(/^\s+/g, '');
        setSearch(value);
        // console.log(value.length > 2,value.length);
        if (value.length > 1)
        {
            if (props.setShowSearchRec != undefined)
            {
                props.setShowSearchRec(true);
            }
            let newFilteredData = filterData();

            let modifyList = [];
            newFilteredData.forEach((item) =>
            {
                let data = item.actualData;
                let keys = Object.keys(data);
                keys.forEach((key) =>
                {
                    if (
                        typeof data[key] === 'string' &&
                        data[key].toLowerCase().indexOf(value.toLowerCase()) >
                        -1
                    )
                    {
                        if (modifyList.indexOf(item) == -1)
                            modifyList.push(item);
                    }
                });
            });
            setFilterListData(modifyList);
            if (props.filterListData) props.filterListData(modifyList);
        } else
        {
            if (props.setShowSearchRec != undefined)
            {
                props.setShowSearchRec(false);
            }
            setFilterListData(listData);
            if (props.filterListData) props.filterListData(listData);
        }
    };
    const onCheckSelect = (event, index) =>
    {

        let newFilterList = [...filterListData];
        newFilterList[index]['selected'] = event.target.checked;
        setFilterListData(newFilterList)
        props.setBulkInviteSelected(false);
        const data = filterData();
        const newFilterList1 = data.map(item =>
        {
            newFilterList.filter(data =>
            {
                if (data.actualData.userID === item.actualData.userID)
                {
                    console.log(data);
                    item = data
                }
            })
            return item

        })
        props.setSearchData(newFilterList1)

    };
    const onCheckSelectAll = (event) =>
    {
        // let newFilterList = [...filterListData];
        let newFilterList = filterData();
        newFilterList.forEach((item, index) =>
        {
            if (props.showSendInvite && props.showSendInvite !== undefined)
            {
                if (item.actualData.email !== null)
                {
                    const nbaDomain = item.actualData.email.split('@');
                    if (
                        item.actualData.registerDate === null &&
                        nbaDomain &&
                        nbaDomain[1] !== 'nba.com'
                    )
                    {
                        newFilterList[index]['selected'] = event.target.checked;
                    }
                }
            } else
            {
                newFilterList[index]['selected'] = event.target.checked;
            }
        });
        setFilterListData(newFilterList);
        props.setBulkInviteSelected(true);
        props.setSearchData([])

    };

    const onChangeHotelRoom = (event, index) =>
    {
        setHotelRoomTaxID({
            ...hotelRoomTaxID,
            index: index,
            value: event.target.value,
        });
        let newFilterList = [...filterListData];
        newFilterList[index]['selected'] = event.target.value;
        setFilterListData(newFilterList);
    };

    const handleEditAll = () =>
    {
        props.editAllToggle();
    };
    const handleHotelSave = () =>
    {
        let newFilterList = [...filterListData];
        props.editAll(newFilterList);
    };

    return (
        <Box className={classes.boxContent}>
            {props.moduleToShow ? <Title title={props.moduleToShow} /> : null}
            {props.moduleToShow != undefined &&
                eventState.eventDetail.get() &&
                ((moduleIndex.get() >= 0 &&
                    eventState.eventDetail.get().moduleDetails[
                        moduleIndex.get()
                    ].details != null) ||
                    '') && (
                    <DetailsComponent
                        data={
                            eventState.eventDetail.get().moduleDetails[
                                moduleIndex.get()
                            ].details
                        }
                    />
                )}
            <EnhancedTableToolbar
                {...props}
                search={search}
                showSendAll={props.showSendAll ? true : false}
                sendAllbuttonTitle={props.showSendAll ? 'Send All' : null}
                showEdit={props.showEdit ? true : false}
                editButtonTitle={props.showEdit ? true : false}
                handleSearchChange={handleOnChange}
                handleFilterChange={handleFilterChangeValue}
                handleSendEmail={props.handleSendEmail}
                hideAdd={props.hideAdd ? true : false}
                modPermission={props.modPermission}
                disableAdd={props.disableAdd}
                onCheckSelectAll={onCheckSelectAll}
                showEditHotel={props.showEditHotel ? true : false}
                handleEditAll={handleEditAll}
                showHotelToggle={props.showHotelToggle}
                saveHotelButtonTitle={props.saveHotelButtonTitle}
                handleHotelSave={handleHotelSave}
                eventConfigStatus={props.eventConfigStatus}
                compUsed={props.compUsed}
                purchaseUsed={props.purchaseUsed}
            />

            {
                <List className={classes.listContent}>
                    {filterListData && filterListData.length > 0 ? (
                        filterListData.map((item, index) => (
                            <DataListRow
                                {...props}
                                key={`datarow_${index}`}
                                item={item}
                                index={index}
                                onCheckSelect={onCheckSelect}
                                onCheckSelectAll={onCheckSelectAll}
                                editRow={props.editRow}
                                editTemplate={props.editTemplate}
                                editSendEmail={props.editSendEmail}
                                viewPage={props.viewPage}
                                onSwitchToggle={props.onSwitchToggle}
                                onActionClick={props.onActionClick}
                                onPendingAction={props.onPendingAction}
                                addConnection={props.addConnection}
                                addConnectionLinkedWith={
                                    props.addConnectionLinkedWith
                                }
                                deleteConnection={props.deleteConnection}
                                modPermission={props.modPermission}
                                copyToClipboard={props.copyToClipboard}
                                outfitInfo={props.outfitInfo}
                                onChangeHotelRoom={onChangeHotelRoom}
                                hotelRoomTaxID={hotelRoomTaxID}
                                hotelKeyValue={props.hotelKeyValue}
                            />
                        ))
                    ) : (
                        <ListItem className={classes.listItemContent}>
                            <Card
                                classes={{ root: classes.paperContent }}
                                sx={{ width: '100%' }}>
                                <CardContent
                                    sx={{ p: 2 }}
                                    className={classes.cardContent}>
                                    <Box className={classes.rowContent}>
                                        No data found
                                    </Box>
                                </CardContent>
                            </Card>
                        </ListItem>
                    )}
                </List>
            }

            {props.pagingInfo &&
                props.pagingInfo.noOfPages > 1 &&
                !props.showSearchRec ? (
                <Box
                    sx={{
                        p: 2,
                        display: 'flex',
                        width: '100%',
                        justifyContent: 'center',
                        alignItems: 'center',
                    }}>
                    <Paging
                        pagingInfo={props.pagingInfo}
                        handlePageChange={props.handlePageChange}
                    />
                </Box>
            ) : null}
        </Box>
    );
};

export default DataList;
